import {JsonProperty} from '../shared/decorators/json-property';
import {getAccountNameByType} from "../shared/utils/helper";

export class AccountsModel {
  login: number;
  leverage: number;
  credit: number;
  balance: number;
  @JsonProperty('margin_free')
  marginFree: number;
  @JsonProperty('account_type')
  accountType: number;
  currency: string;
  @JsonProperty('group_name')
  groupName: string;
  @JsonProperty('is_mam') isMam: string;
  mt5_create_time: number;
  ib_id: number;
  constructor() {
    this.login = undefined;
    this.isMam = undefined;
    this.leverage = undefined;
    this.balance = undefined;
    this.marginFree = undefined;
    this.accountType = undefined;
    this.currency = undefined;
    this.credit = undefined;
    this.groupName = undefined;
    this.mt5_create_time = undefined;
    this.ib_id = undefined;
  }

  getAccountType(): any {
    return getAccountNameByType(this);
  }
}
